export const generateSitemap = async (newUrls) => {
  try {
    const today = new Date().toISOString().split("T")[0];

    // Fetch the existing sitemap from the public folder
    const response = await fetch(`/sitemap-${today}.xml`);
    console.log({ response });
    let existingXml = "";

    if (response.ok) {
      existingXml = await response.text();
      console.log("✅ Existing sitemap loaded.");
    } else {
      // If not found, create a new one
      existingXml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
</urlset>`;
      console.warn("⚠️ sitemap.xml not found. Creating a new one.");
    }

    const newEntries = newUrls
      .map(
        (loc) => `  <url>
    <loc>${loc}</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.9</priority>
  </url>`
      )
      .join("\n");

    // Append new URLs before the closing </urlset>
    const updatedXml = existingXml.replace(
      "</urlset>",
      `${newEntries}\n</urlset>`
    );

    // Create a downloadable XML file
    const blob = new Blob([updatedXml], { type: "application/xml" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `sitemap-${today}.xml`;
    link.click();
    URL.revokeObjectURL(link.href);

    console.log("✅ sitemap.xml updated and downloaded!");
  } catch (error) {
    console.error("❌ Error updating sitemap:", error);
  }
};
